import { render, staticRenderFns } from "./Retirarreceta.vue?vue&type=template&id=6421d33e&scoped=true"
import script from "./Retirarreceta.vue?vue&type=script&lang=js"
export * from "./Retirarreceta.vue?vue&type=script&lang=js"
import style0 from "./Retirarreceta.vue?vue&type=style&index=0&id=6421d33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421d33e",
  null
  
)

export default component.exports